module.exports = __webpack_public_path__ + "06be74b1d70418cee07702f4b2a4dfec.pdf";